
import './App.css';
import { useEffect } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Home from './components/Home'
import Works from './components/Works';
import ProjectInfo from './components/ProjectInfo';
import About from './components/About';
function App() {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, []);
  return (
<BrowserRouter>
<Routes>
  <Route path='/' element={<Home/>}/>
  <Route path='/works' element={<Works/>}/>
  <Route path='/:slug' element={<ProjectInfo/>}/>
  <Route path='/about' element={<About/>}/>


</Routes>
</BrowserRouter>
  );
}

export default App;
